exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:768px){.title-between-line[data-v-2ff984cc]:after,.title-between-line[data-v-2ff984cc]:before{content:\"\";border-top:2px solid #d20b12;margin:0 20px 0 0;-webkit-box-flex:1;-ms-flex:1 0 20px;flex:1 0 20px}.title-between-line[data-v-2ff984cc]:after{margin:0 0 0 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2ff984cc","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/SectionTitleMobileLine.vue
// module id = 6WXQ
// module chunks = 1